import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { paths } from '../../../../routing/path';

export interface MyNonprofitMenuItemProps {
    charityId: number | string;
    onClickExtra?: () => void;
}

export const MyNonprofitMenuItem = (props: MyNonprofitMenuItemProps) => (
    <LeftMenuItem
        icon="pe-7s-network"
        label="My Nonprofit"
        to={paths.venues.share.charityEdit(props.charityId)}
        trackingAction="My Charity"
        gtmCategory="My Charity"
        forceReload
        onClickExtra={props.onClickExtra}
    />
);
